export const account_types = [
    {
        title: '标准化',
        key: 'standardization',
    },
    {
        title: '信息流',
        key: 'feed_flow',
    },
    {
        title: 'KOL平台充值',
        key: 'platform_recharge',
    },
    {
        title: '其它',
        key: 'other',
    }
]

export const account_type_hash_title = account_types.reduce((t, i) => {
    t[i.key] = i.title
    return t
}, {})

export const account_status = [
    {
        title: '正常使用',
        key: 'usable',
    },
    {
        title: '暂停使用',
        key: 'suspend',
    },
    {
        title: '退款中',
        key: 'refund',
    },
    {
        title: '已停用',
        key: 'disable',
    }
]

export const account_status_hash_title = account_status.reduce((t, i) => {
    t[i.key] = i.title
    return t
}, {})